"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const ConfirmModal_1 = __importDefault(require("chaire-lib-frontend/lib/components/modal/ConfirmModal"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const DeleteGroupedObjectButton = (props) => {
    const [deletePlaceModalOpened, setDeletePlaceModalOpened] = react_1.default.useState(false);
    const beforeRemoveGroupedObject = (e) => {
        var _a;
        e.preventDefault();
        const hasConfirmPopup = props.widgetConfig.deleteConfirmPopup;
        const confirmPopupConditional = hasConfirmPopup
            ? (0, helpers_1.parseBoolean)((_a = props.widgetConfig.deleteConfirmPopup) === null || _a === void 0 ? void 0 : _a.conditional, props.interview, props.path, props.user)
            : true;
        if (hasConfirmPopup && confirmPopupConditional === true) {
            setDeletePlaceModalOpened(true);
        }
        else {
            onRemoveGroupedObject();
        }
    };
    const onRemoveGroupedObject = (e) => {
        if (e) {
            e.preventDefault();
        }
        props.startRemoveGroupedObjects(props.path);
    };
    const widgetConfig = props.widgetConfig;
    const showDeleteButton = (0, helpers_1.parseBoolean)(props.widgetConfig.showGroupedObjectDeleteButton, props.interview, props.path, props.user, false);
    const deleteButtonLabel = (0, helpers_1.translateString)(props.widgetConfig.groupedObjectDeleteButtonLabel, props.i18n, props.interview, props.path) ||
        props.t([`${props.shortname}:deleteThisGroupedObject`, `survey:${props.shortname}:deleteThisGroupedObject`]);
    return showDeleteButton ? (react_1.default.createElement("div", { className: "center" },
        react_1.default.createElement("button", { type: "button", className: "button red small", onClick: beforeRemoveGroupedObject },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashAlt, className: "faIconLeft" }),
            deleteButtonLabel),
        deletePlaceModalOpened &&
            widgetConfig.deleteConfirmPopup &&
            widgetConfig.deleteConfirmPopup.content &&
            widgetConfig.deleteConfirmPopup.content[props.i18n.language] && (react_1.default.createElement("div", null,
            react_1.default.createElement(ConfirmModal_1.default, { isOpen: true, closeModal: () => setDeletePlaceModalOpened(false), text: (0, helpers_1.parseString)(widgetConfig.deleteConfirmPopup.content[props.i18n.language] ||
                    widgetConfig.deleteConfirmPopup.content, props.interview, props.path), title: (0, helpers_1.translateString)(widgetConfig.deleteConfirmPopup.title, props.i18n, props.interview, props.path) || '', cancelAction: widgetConfig.deleteConfirmPopup.cancelAction, confirmAction: (e) => onRemoveGroupedObject(e), containsHtml: widgetConfig.deleteConfirmPopup.containsHtml }))))) : null;
};
exports.default = (0, react_i18next_1.withTranslation)()(DeleteGroupedObjectButton);
//# sourceMappingURL=DeleteGroupedObjectButton.js.map